import React from "react";
import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { useGetStudentInstructorQuery } from "../../../store/studentApi";
import InstructorStudentList from "../../ui/InstructorStudentList";

type StudentsSectionProps = {
  searchTerm: string;
};

const StudentsSection: React.FC<StudentsSectionProps> = ({ searchTerm }) => {
  const { data: students } = useGetStudentInstructorQuery();

  const filteredStudents =
    (searchTerm.trim() === ""
      ? students
      : students?.filter((student: any) =>
          (student?.fname || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
        )) || [];

  const activeStudents = filteredStudents?.filter(
    (student: any) => student.status === "Active"
  );
  const disableStudents = filteredStudents?.filter(
    (student: any) => student.status === "Disable"
  );

  return (
    <Card className="w-full">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 py-4 px-4 sm:px-6">
        <CardTitle  >Student Management</CardTitle>
        <CardContent className="p-0 text-sm sm:text-sm font-semibold sm:flex sm:space-x-5 ">
          <h1>Total Students: {students?.length || 0}</h1>
          <h1 className="text-[]">
            Active students : {activeStudents?.length}
          </h1>
          <h1 className="text-red-600">
            Disabled Students : {disableStudents?.length}
          </h1>
        </CardContent>
      </div>

      <CardContent className="px-4 sm:px-6">
        <InstructorStudentList students={filteredStudents} />
      </CardContent>
    </Card>
  );
};

export default StudentsSection;
